import { Injectable } from '@angular/core';
import { Observable, of, combineLatest, timer, BehaviorSubject } from 'rxjs';
import { switchMap, debounceTime, map, distinctUntilChanged, tap, mergeMap } from 'rxjs/operators';
import { sharePublishReplay } from 'ngx-libs';
import { EthWalletService, Status } from './eth-wallet.service';
import { GtagService } from './gtag.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  accounts: Observable<string[]>;
  account: Observable<string>;
  isObserving: Observable<boolean>;

  // private observeUpdater = new BehaviorSubject(localStorage.getItem('OBSERVE_ADDRESS'));
  private observeUpdater = new BehaviorSubject('');

  constructor(
    private ethWalletService: EthWalletService,
    private gtagService: GtagService
  ) {
    const walletSource = combineLatest([this.ethWalletService.status, timer(0, 1000)]).pipe(
      debounceTime(10),
      switchMap(([status]) => status === Status.Connected ? this.ethWalletService.getAccounts() : of([]))
    );

    const observeSource = this.observeUpdater.pipe(
      map((a) => a ? [a] : [])
    );

    this.isObserving = observeSource.pipe(
      map((os) => os.length > 0)
    );

    this.accounts = combineLatest([walletSource, observeSource]).pipe(
      map(([ws, os]) => os.length ? os : ws),
      distinctUntilChanged((a, b) => a.toString() === b.toString()),
      tap((accounts) => {
        if (accounts[0]) {
          this.gtagService.gtag('set', 'user_properties', {
            wallet_address: `_${accounts[0]}`
          });
          this.gtagService.gtag('event', 'connect_wallet');
        }
      }),
      sharePublishReplay(1)
    );

    this.account = this.accounts.pipe(map(acounts => acounts[0]));
  }

  setObserveAddress(address: string) {
    // localStorage.setItem('OBSERVE_ADDRESS', address);
    this.observeUpdater.next(address);
  }

  removeObserveAddress() {
    // localStorage.removeItem('OBSERVE_ADDRESS');
    this.observeUpdater.next(null);
  }

  getNonce() {
    return this.account.pipe(
      mergeMap((a) => a ? this.ethWalletService.getTransactionCount(a) : of(0))
    );
  }
}
